import React from 'react';

const SwitchButton = (
  {
    leftValue,
    rightValue,
    switchValue = '',
    setSwitchValue = null
  }: {
    leftValue: string,
    rightValue: string,
    switchValue?: string,
    setSwitchValue?: any
  }
) => {
  if (!switchValue || !setSwitchValue) return null;

  return (
    <label className="toggle-container">
      <span>{leftValue}</span>
      <input type="checkbox" className="hidden peer" defaultChecked={switchValue === rightValue}/>
      <div
        className={`toggle-switch ${switchValue === rightValue ? 'active' : ''}`}
        onClick={() => setSwitchValue(switchValue === rightValue ? leftValue : rightValue)}
      />
      <span>{rightValue}</span>
    </label>
  );
};

export default SwitchButton;